import PropTypes from "prop-types";
import * as React from "react";
import { Button, Dialog } from "../../themeV2";
import CharacterDetailsFields from "./CharacterDetailsFields";

export default function DetailsDialog({ image, roles, onSave, onClose }) {
  const [details, setDetails] = React.useState({
    label: image?.label ?? null,
    influencerCharacterId: image?.influencerCharacterId ?? null,
  });

  React.useEffect(() => {
    setDetails({
      label: image?.label ?? null,
      influencerCharacterId: image?.influencerCharacterId ?? null,
    });
  }, [image]);

  return (
    <Dialog.Root
      open={Boolean(image)}
      onOpenChange={(open) => !open && onClose()}
    >
      <Dialog.Popup size="sm">
        <Dialog.Title>Edit details</Dialog.Title>
        <Dialog.Close />
        <CharacterDetailsFields
          label={details.label}
          influencerCharacterId={details.influencerCharacterId}
          roles={roles}
          onDetailsChange={(changes) =>
            setDetails((current) => ({ ...current, ...changes }))
          }
        />
        <Dialog.Actions>
          <Button variant="text" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="filled" onClick={() => onSave(image, details)}>
            Save
          </Button>
        </Dialog.Actions>
      </Dialog.Popup>
    </Dialog.Root>
  );
}

DetailsDialog.propTypes = {
  image: PropTypes.object,
  roles: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
